import { useQuery } from '@tanstack/react-query'
import { calendarDetailsMockData } from 'src/charts/CalendarDetails/mockData/calendarDetailsMockData'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import { AnalyticsFetchCalendarDetailsResponse } from 'src/services/__generated__/api'
import { useGetHomeCalendarDetailsQueryParams } from './interfaces/useGetHomeCalendarDetailsQuery.interface'

const USE_MOCK_DATA = false // Set to false to use real API

const getHomeCalendarDetails = async (
  date: string | null
): Promise<AnalyticsFetchCalendarDetailsResponse | undefined> => {
  if (!date) {
    return undefined
  }

  // Return mock data if enabled
  if (USE_MOCK_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(calendarDetailsMockData), 300)
    })
  }

  const { data } =
    await AnalyticsApi.v1Private.analyticsFetchCalendarDetailsList({ date })

  return data
}

export const useGetHomeCalendarDetailsQuery = (
  params: useGetHomeCalendarDetailsQueryParams
) => {
  return useQuery({
    queryFn: () => getHomeCalendarDetails(params.date),
    queryKey: [QueryKey.GET_HOME_CALENDAR_DETAILS],
  })
}
